<template>
  <div class="inner-box">
    <div slot="content">
      <el-form size="medium" @submit.prevent="save">
        <div class="content-name">
          <h2 class="dp-ib">{{ routeName }}</h2>
          <el-form-item label-width="0px" style="float: right;">
            <el-button type="primary" icon="el-icon-search" @click="goOpen">
              {{ this.$i18n.messages[this.$store.state.locale].search }}
            </el-button>
            <el-button type="success" icon="el-icon-document-checked" @click="excelDown">엑셀</el-button>
          </el-form-item>
        </div>
      </el-form>

      <div class="search-form">
        <el-form size="mini">
          <el-row style="margin-bottom: 0px;">
            <el-col :span="4">
              <el-form-item label="제조사" label-width="80px">
                <el-select v-model="form.maker" >
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['maker']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="제품군" label-width="80px">
                <el-col :span="10">
                  <el-select v-model="form.itemGroup" @change="onItemGroupChange">
                    <el-option value='' label="전체">전체</el-option>
                    <el-option
                        v-for="item in combos['itemGroup']"
                        :key="item.key"
                        :value="item.key"
                        :label="item.value">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="14">
                  <el-select v-model="form.subItemGroup" v-show="changeItemGroupShow">
                    <el-option value='' label="전체">전체</el-option>
                    <el-option
                        v-for="item in combos['subItemGroup']"
                        :key="item.key"
                        :value="item.key"
                        :label="item.value">
                    </el-option>
                  </el-select>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="품번" label-width="60px">
                <el-input type="text" v-model="form.itemCd" @keyup.native.enter="goOpen"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="지역/센터" label-width="100px">
                <el-col :span="10">
                  <el-select v-model="form.catId" @change="onCatIdChange">
                    <el-option value='' label="전체">전체</el-option>
                    <el-option
                        v-for="item in combos['catId']"
                        :key="item.key"
                        :value="item.key"
                        :label="item.value">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="14">
                  <el-select v-model="form.subCatId" v-show="changeCatIdShow">
                    <el-option value='' label="전체">전체</el-option>
                    <el-option
                        v-for="item in combos['subCatId']"
                        :key="item.key"
                        :value="item.key"
                        :label="item.value">
                    </el-option>
                  </el-select>
                </el-col>
              </el-form-item>
            </el-col>

          </el-row>
        </el-form>
      </div>
    </div>

    <div class="table-area">
      <div class="table-b">
        <div class="table-header">
          <div class="grid-tbl-box">
            <ag-grid-vue
                ref="grid"
                :style="gridStyle"
                class="ag-theme-alpine"
                :column-defs="columnDefs"
                :grid-options="mainGridOptions"
                :row-data="data"
                :default-col-def="defaultColDef"
                :framework-components="frameworkComponent"
                :statusBar="statusBar"
                :enableRangeSelection="true"
                @cell-clicked="onCellClicked"
                @grid-ready="onReadyMain" />
          </div>


          <div class="grid-tbl-box" v-show="false">
            <ag-grid-vue
                ref="excelGrid"
                :style="gridStyle"
                class="ag-theme-alpine"
                :column-defs="excelColumnDefs"
                :grid-options="excelGridOptions"
                :row-data="excelData"
                :default-col-def="defaultColDef"
                :framework-components="frameworkComponent"
                @grid-ready="onReadyExcel"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from "@/mixin/lucoms";
import DatepickerCellRenderer from "@/components/agGrid/datepicker-cell-renderer";
import MaskEditCellRenderer from "@/components/agGrid/maskedit-cell-renderer";
import SelectCellRenderer from "@/components/agGrid/select-cell-renderer";
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";
import RadioCellRenderer from "@/components/agGrid/radio-cell-renderer";
import NumberInputCellRender from "@/components/agGrid/numberinput-cell-renderer";
import InputCellRender from "@/components/agGrid/input-cell-renderer";
import ButtonCellRenderer from "@/components/agGrid/button-cell-renderer";
import ReceptionModal_01 from "@/components/AS/History/Modal/ReceptionModal_01";

import ImgUpload from "@/components/InfoManage/MaterialsMng/ImgUpload";

function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

export default {
  mixins: [mixin],
  props: {
  },
  data() {
    return {
      data: [],
      excelData: [],
      form: {
        companyId : '',
        maker : '',              // 제조사
        itemGroup : '',          // 제품군
        subItemGroup : '',       // 제품상세
        useModelNm : '',
        itemCd : '',             // 품번
        catId : '',              // 지역
        subCatId: '',            // 지역 상세
        asAgentId : 0,
        sortType : '',
        page : 1,
        totalPage : 99999,
        curPage : 0,
        totalCount : 99999,
        processTime : ''
      },
      combos: {
        'maker' : [],            //제조사
        'itemGroup' : [],        //제품군
        'subItemGroup' : [],     //sub제품군
        'catId' : [],            //지역센터
        'subCatId' : [],         //지역상세
      },
      // AG-GRID OPTION [START]
      gridStyle : 'padding-top: 20px; width: 100%;height: 700px; min-height:100px;',
      defaultColDef: {
          resizable: true
        , filter:true
        , sortable: true
      },
      mainGridApi: null,
      mainColumnApi: null,
      mainGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
      },
      excelGridApi: null,
      excelColumnApi: null,
      excelGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
        excelStyles: [
          { id: 'numberType',numberFormat: {format: '0',}},
          { id: 'stringType', dataType: 'String'},
          { id: 'dateType', dataType: 'DateTime'},
        ],
      },
      columnDefs: [],
      excelColumnDefs: [],
      frameworkComponent : {
        datePicker: DatepickerCellRenderer,
        maskEdit: MaskEditCellRenderer,
        select: SelectCellRenderer,
        checkBox: CheckboxCellRenderer,
        radio: RadioCellRenderer,
        numberInput: NumberInputCellRender,
        input: InputCellRender,
        button: ButtonCellRenderer
      },
      statusBar: null,
      changeCatIdShow : false,
      changeItemGroupShow : false,
    }
  },
  methods: {
    onReadyMain() {
      this.mainGridApi = this.mainGridOptions.api;
      this.mainColumnApi = this.mainGridOptions.columnApi;

      this.init();
    },
    onReadyExcel() {
      this.excelGridApi = this.excelGridOptions.api;
      this.excelColumnApi = this.excelGridOptions.columnApi;
    },
    createMainColumnDefs() {
      let that = this;
      this.columnDefs = [
        {
          headerName:'No',
          field:'no',
          width:80,
          cellStyle:{textAlign: 'center'},
          valueFormatter: function(params) {
            return params.node.rowIndex+1;
          }
        },
        {headerName:'제품군', field:'itemGroupNm', cellStyle:{textAlign: 'center'}, width:120},
        {headerName:'대표모델', field:'useModelNm', width:180},
        {headerName:'품번', field:'itemCd', width:200, 
          cellRenderer: (params) => {
            return `<div style="text-decoration: underline; text-underline-position: under; color:blue; cursor:pointer;">${params.value}</div>`;
          }
        },
        {headerName:'품번ID', field:'itemId', hide: true},
        {headerName:'품명', field:'itemNm', width:260},
        {headerName:'규격', field:'itemSpec', width:220},
        {headerName:'센터명', field:'asAgentNm', width:140, cellStyle:{textAlign: 'center'}},
        {headerName:'양품재고(반품중)', field:'evalOutGoodQty', width:160, cellStyle:{textAlign: 'right'},
          valueGetter: (params) => {
            return that.evalOutGoodQty(params);
          },
          // valueFormatter: (params) => {
          //   return that.getNumberFormat(params.value);
          // }
        },
        {headerName:'불량재고(반품중)', field:'standardModelNm', width:160, cellStyle:{textAlign: 'right'},
          valueGetter: (params) => {
            return that.evalOutBadQty(params);
          },
          // valueFormatter: (params) => {
          //   return that.getNumberFormat(params.value);
          // }
        },
        {headerName:'총재고(반품중)', field:'modelNm', width:160, cellStyle:{textAlign: 'right'},
          valueGetter: (params) => {
            return that.evalOutTotalQty(params);
          },
          // valueFormatter: (params) => {
          //   return that.getNumberFormat(params.value);
          // }
        },
      ];
    },
    createExcelColumnDefs() {
      const that = this;
      this.excelColumnDefs = [
        {headerName:'제품군', field:'itemGroupNm', cellStyle:{textAlign: 'center'}, width:120, cellClass: 'stringType'},
        {headerName:'대표모델', field:'useModelNm', width:180, cellClass: 'stringType'},
        {headerName:'품번', field:'itemCd', width:200, cellClass: 'stringType'},
        {headerName:'품명', field:'itemNm', width:260, cellClass: 'stringType'},
        {headerName:'규격', field:'itemSpec', width:220, cellClass: 'stringType'},
        {headerName:'센터명', field:'asAgentNm', width:140, cellStyle:{textAlign: 'center'}, cellClass: 'stringType'},
        {headerName:'양품재고', field:'goodQty', width:160, cellStyle:{textAlign: 'right'},
          valueFormatter: (params) => {
            return that.getNumberFormat(params.value);
          }
        },
        {headerName:'불량재고', field:'badQty', width:160, cellStyle:{textAlign: 'right'},
          valueFormatter: (params) => {
            return that.getNumberFormat(params.value);
          }
        },
        {headerName:'양품재고(반품중)', field:'evalOutGoodQty', width:160, cellStyle:{textAlign: 'right'},
          valueGetter: (params) => {
            return that.evalOutGoodQty(params);
          },
        },
        {headerName:'불량재고(반품중)', field:'standardModelNm', width:160, cellStyle:{textAlign: 'right'},
          valueGetter: (params) => {
            return that.evalOutBadQty(params);
          },
        },
        {headerName:'총재고(반품중)', field:'modelNm', width:160, cellStyle:{textAlign: 'right'},
          valueGetter: (params) => {
            return that.evalOutTotalQty(params);
          },
        },
        {headerName:'이평단가', field:'unitPrice1', width:160, cellStyle:{textAlign: 'right'},
          valueFormatter: (params) => {
            return that.getNumberFormat(params.value);
          }
        },
        {headerName:'양품금액', field:'goodAmt1', width:160, cellStyle:{textAlign: 'right'},
          valueFormatter: (params) => {
            return that.getNumberFormat(params.value);
          }
        },
        {headerName:'불량금액', field:'badAmt1', width:160, cellStyle:{textAlign: 'right'},
          valueFormatter: (params) => {
            return that.getNumberFormat(params.value);
          }
        },
        {headerName:'반품중양품금액', field:'outGoodQtyUnitPrice1', width:160, cellStyle:{textAlign: 'right'},
          valueGetter: (params) => {
            return that.getNumberFormat(params.data.outGoodQty * params.data.unitPrice1);
          }
        },
        {headerName:'반품중불량금액', field:'outBadQtyUnitPrice1', width:160, cellStyle:{textAlign: 'right'},
          valueGetter: (params) => {
            return that.getNumberFormat(params.data.outBadQty * params.data.unitPrice1);
          }
        },
        {headerName:'이평단가합계', field:'totalUnitPrice1', width:160, cellStyle:{textAlign: 'right'},
          valueGetter: (params) => {
            return that.getNumberFormat(params.data.unitAmt1
                + (params.data.outGoodQty * params.data.unitPrice1)
                + (params.data.outBadQty * params.data.unitPrice1)
            );
          }
        },
        {headerName:'운영단가', field:'unitPrice2', width:160, cellStyle:{textAlign: 'right'},
          valueFormatter: (params) => {
            return that.getNumberFormat(params.value);
          }
        },
        {headerName:'운영단가양품금액', field:'goodAmt2', width:160, cellStyle:{textAlign: 'right'},
          valueFormatter: (params) => {
            return that.getNumberFormat(params.value);
          }
        },
        {headerName:'운영단가불량금액', field:'badAmt2', width:160, cellStyle:{textAlign: 'right'},
          valueFormatter: (params) => {
            return that.getNumberFormat(params.value);
          }
        },
        {headerName:'반품중양품금액', field:'outGoodQtyUnitPrice2', width:160, cellStyle:{textAlign: 'right'},
          valueGetter: (params) => {
            return that.getNumberFormat(params.data.outGoodQty * params.data.unitPrice2)
          }
        },
        {headerName:'반품중불량금액', field:'outBadQtyUnitPrice2', width:160, cellStyle:{textAlign: 'right'},
          valueGetter: (params) => {
            return that.getNumberFormat(params.data.outBadQty * params.data.unitPrice2)
          }
        },
        {headerName:'운영단가합계', field:'totalUnitPrice2', width:160, cellStyle:{textAlign: 'right'},
          valueGetter: (params) => {
            return that.getNumberFormat(that.evalTotalUnitPrice2(params));
          },
        },
    ];
    },
    onCellClicked(params) {

      const field = params.colDef.field;
      if(field === 'itemCd') {
        this.$modal.open({
          width: 800,
          component: ImgUpload,
          parent: this,
          props: {
              srcId2 : params.data.itemId,
              srcId3 : 'Item',
              attachYn : 'Y',
              isUpload: false
          },
        });
      }

    },
    goOpen() {
      let that = this
      this.$store.commit('loading')

      const vForm = {
        companyId :this.form.companyId,
        maker : this.form.maker,                         // 제조사
        itemGroup : (this.form.subItemGroup.length <= 0 || this.form.subItemGroup === '')  ? this.form.itemGroup : this.form.subItemGroup,                // 제품군
        useModelNm : this.form.useModelNm,
        itemCd : this.form.itemCd,
        catId : (this.form.subCatId.length <= 0 || this.form.subCatId === '')  ? (this.form.catId === '' ? 0 : this.form.catId) : this.form.subCatId,     // 지역
        asAgentId : this.form.asAgentId,
        sortType : this.form.sortType,
        page : this.form.page,
        totalPage : this.form.totalPage,
        curPage : this.form.curPage,
        totalCount : this.form.totalCount,
        processTime : this.form.processTime
      }

      this.$http.post(_url("/api/workMng/mateStock/list"), vForm)
          .then(response => {
            this.data = response.data
            console.log(this.data);
          })
          .finally(() => {
            this.$store.commit('finish')
          });
    },
    save() {
      console.log('test',this.$parent.$refs.step.next())
    },
    onCatIdChange(param){
      this.form.subCatId = '';
      if(param === '') this.changeCatIdShow =  false;
      else{
        this.changeCatIdShow =  true;
        // 지역 상세
        this.$http.get(`/api/codeMng/combo/catId`, { params: {parentId: param} })
            .then(response => {
              this.combos['subCatId'] = response.data || []
            });
      }
    },
    onItemGroupChange(param){
      this.form.subItemGroup = '';
      if(param === '') this.changeItemGroupShow =  false;
      else{
        this.changeItemGroupShow =  true
        // 제품군
        this.$http.get(`/api/codeMng/detail`, { params: {parentId: 143} })  // 제품군
            .then(response => {
              let subData = response.data.filter(x => x.catKey === param);
              this.$http.get(`/api/codeMng/combo`, { params: {parentId: subData[0].catId} })
                  .then(response => {
                    this.combos['subItemGroup'] = response.data || []
                  });
            });
      }
    },
    async init() {
      this.$store.commit('loading');
      await this.$http.post(`/api/workMng/mateStock/init`)
          .then(response => {
            this.combos['maker'] = response.data.maker;          //제조사
            this.combos['catId'] = response.data.catId;          //지역센터
            this.combos['itemGroup'] = response.data.itemGroup;  //제품군
          }).finally(() => {
            this.goOpen();
            this.$store.commit('finish');
          });

      this.createMainColumnDefs();
      this.createExcelColumnDefs();
    },
    evalOutGoodQty(params){
      var result = '';
      var val = params.data;
      if(params.data !== null ){
        if (val.goodQty === 0 && val.outGoodQty > 0) result = val.outGoodQty + "(" + val.outGoodQty + ")";
        else if (val.goodQty > 0 && val.outGoodQty > 0) result = (val.goodQty + val.outGoodQty) + "(" + val.outGoodQty + ")";
        else if (val.goodQty > 0 && val.outGoodQty == 0) result = val.goodQty;
        else {
          if(val === "") result =  '';
          else result =  0;
        }
      }
      return result;
    },
    evalOutBadQty(params){
      var result = '';
      var val = params.data;

      if(params.data !== null ) {
        if (val.badQty === 0 && val.outBadQty > 0) result = val.outBadQty + "(" + val.outBadQty + ")";
        else if (val.badQty > 0 && val.outBadQty > 0) result = (val.badQty + val.outBadQty) + "(" + val.outBadQty + ")";
        else if (val.badQty > 0 && val.outBadQty == 0) result = val.badQty;
        else {
          if (val === "") result = '';
          else result = 0;
        }
      }
      return result;
    },
    evalOutTotalQty(params){
      var result = '';
      var val = params.data;
      if(params.data !== null ) {
        if (val.totalQty === 0 && val.outTotalQty > 0) result = val.outTotalQty + "(" + val.outTotalQty + ")";
        else if (val.totalQty > 0 && val.outTotalQty > 0) result = (val.totalQty + val.outTotalQty) + "(" + val.outTotalQty + ")";
        else if (val.totalQty > 0 && val.outTotalQty == 0) result = val.totalQty;
        else {
          if (val === "") result = '';
          else result = 0;
        }
      }
      return result;
    },
    evalTotalUnitPrice2(params){
      var result = '';
      var val = params.data;

      if(params.data !== null ) {
        result = val.unitAmt2 + (val.outGoodQty * val.unitPrice2) + (val.outBadQty * val.unitPrice2)
      }
      return result;
    },

    excelDown(){
      const vForm = {
        companyId :this.form.companyId,
        maker : this.form.maker,                         // 제조사
        itemGroup : (this.form.subItemGroup.length <= 0 || this.form.subItemGroup === '')  ? this.form.itemGroup : this.form.subItemGroup,                // 제품군
        useModelNm : this.form.useModelNm,
        itemCd : this.form.itemCd,
        catId : (this.form.subCatId.length <= 0 || this.form.subCatId === '')  ? (this.form.catId === '' ? 0 : this.form.catId) : this.form.subCatId,     // 지역
        asAgentId : this.form.asAgentId,
        sortType : this.form.sortType,
        page : this.form.page,
        totalPage : this.form.totalPage,
        curPage : this.form.curPage,
        totalCount : this.form.totalCount,
        processTime : this.form.processTime
      }

      this.$store.commit('loading')
      this.$http.post(_url("/api/workMng/mateStock/list"), vForm)
          .then(response => {
            this.excelData = response.data.map(x => {
              return x
            });
            console.log('this.excelData', this.excelData)

          }).finally(() => {
        this.$store.commit('finish');
        var params = {
          fileName : "자재현재고리스트"
        };
        this.excelGridOptions.api.exportDataAsExcel(params);

      });
    }
  },
  created() {
    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
  mounted() {
    this.form.companyId = this.$store.state.loginInfo.compCd;

  },
  computed: {
    routeName() {
      return this.$route.name
    }
  },
}
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>